import { useNavigate } from "react-router-dom";

export default function CallToAction() {
  const navigate = useNavigate();

  return (
    <div className="w-full mt-16">
      <div
        className="font-inter relative mx-auto rounded-xl border border-[#F3E6CF] 
  px-8 py-6 flex items-center overflow-hidden
  bg-[linear-gradient(91.57deg,#FAFCFF_0.24%,#FFEFD4_103.52%)]"
      >
        {/* Left Content */}
        <div className="max-w-[520px]">
          <h2 className="font-bold text-[20px] text-[#111111] mb-2">
            Unlock Your Timeline
          </h2>

          <p className="text-[14px] text-[#444444] leading-[22px] mb-4">
            Gain access to a personalized timeline designed just for you.
            <br />
            <span className="text-[#555555]">
              Get random, goal-oriented tasks that strengthen your profile step
              by step. Start building the foundation for your dream university
              or career — today
            </span>
          </p>

          <button
            onClick={() => navigate("/sap/pricing-plan")}
            className="bg-[#5E2A84] hover:bg-[#532575] text-white text-[14px] font-semibold px-6 py-2 rounded-lg transition"
          >
            Get Personalized Timeline
          </button>
        </div>

        {/* Right Illustration */}
        <div className="absolute right-16 bottom-0 hidden md:block">
          <img
            src="/Pa.png"
            alt="Unlock Timeline"
            className="w-[200px] h-auto"
          />
        </div>
      </div>
    </div>
  );
}
